var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLilArrowLeftDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28711 12L14.2971 18.01L15.7111 16.596L11.1111 11.996L15.7111 7.39599L14.2971 5.98999L8.28711 12Z",
    fill: "#AEB1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLilArrowLeftDisable);
export default __webpack_public_path__ + "static/media/lilArrowLeftDisable.9d49492f914cd24c7dffbb7800e91159.svg";
export { ForwardRef as ReactComponent };